import type { RouteRecordRaw } from 'vue-router';

// Recovery routes per frontend-structure.md + B7.* wireframes.
// B7.3 — next-highest offer accept/decline.
//
// B7.2 (payment-failed recovery) has no route here, and needs none: it is a
// state of B6.2 self-checkout, owned by features/checkout. '/:slug/checkout/retry'
// is gone entirely — the app had no bidders and nothing linked to it, so there
// was no URL worth preserving. Do not re-add it here either: a duplicate static
// path resolves to whichever route registers first, so an entry here is
// silently shadowed.
export const routes: RouteRecordRaw[] = [
  {
    path: '/:slug/offers/:id',
    name: 'recovery-offer',
    component: () => import('./pages/OfferPage.vue'),
    meta: { requiresAuth: true },
  },
];
